import get from 'lodash/fp/get'
import at from 'lodash/fp/at'
import { call, put } from 'redux-saga/effects'
import { createAuthedApiSaga, createRoutineSaga, SAGA_WATCHER_LATEST_MODE } from '../../utils/saga'
import injectSaga from '../../state/hoc/injectSaga'

import { logout } from '../Login/actions'
import loginApi from '../Login/api'
import {
  fetchProfileRoutine,
  updateProfileRoutine,
  updatePasswordRoutine,
  deleteUserRoutine
} from './routines'
import getProfileApi from './api'

// callers
export function * getAuthedApi() {
  const api = yield * createAuthedApiSaga(getProfileApi)

  return api
}

export function * fetchProfileSaga(id) {
  const api = yield * getAuthedApi()
  const result = yield call(api.getById, id)

  return result
}

export function * updateProfileSaga(id, data) {
  const api = yield * getAuthedApi()
  const result = yield call(api.update, id, data)

  return result
}

export function * updatePasswordSaga(id, data) {
  const api = yield * getAuthedApi()
  const result = yield call(api.updatePassword, id, data)

  return result
}

export function * deleteUserSaga(id) {
  const api = yield * getAuthedApi()
  yield call(api.delete, id)
}

// callbacks
export function * onDeleteUserSuccess() {
  loginApi.removeHasUser()
  yield put(logout())
}

// watchers
export const { watcher: fetchProfileByIdWatcher } = createRoutineSaga({
  routine: fetchProfileRoutine,
  requestSaga: fetchProfileSaga,
  requestArgsCreator: get('payload'),
  watcherMode: SAGA_WATCHER_LATEST_MODE
})

export const { watcher: updateProfileWatcher } = createRoutineSaga({
  routine: updateProfileRoutine,
  requestSaga: updateProfileSaga,
  requestArgsCreator: at(['payload.id', 'payload']),
  watcherMode: SAGA_WATCHER_LATEST_MODE
})

export const { watcher: updatePasswordWatcher } = createRoutineSaga({
  routine: updatePasswordRoutine,
  requestSaga: updatePasswordSaga,
  requestArgsCreator: at(['payload.id', 'payload']),
  watcherMode: SAGA_WATCHER_LATEST_MODE
})

export const { watcher: deleteUserWatcher } = createRoutineSaga({
  routine: deleteUserRoutine,
  requestSaga: deleteUserSaga,
  requestArgsCreator: get('payload'),
  onSuccessSaga: onDeleteUserSuccess,
  watcher: SAGA_WATCHER_LATEST_MODE
})

// injectors
export const withFetchProfileByIdSaga = injectSaga({
  key: 'profile/byId',
  saga: fetchProfileByIdWatcher
})

export const withUpdateProfileSaga = injectSaga({
  key: 'profile/update',
  saga: updateProfileWatcher
})

export const withUpdatePasswordSaga = injectSaga({
  key: 'profile/updatePassword',
  saga: updatePasswordWatcher
})

export const withDeleteUserSaga = injectSaga({
  key: 'profile/delete',
  saga: deleteUserWatcher
})
